import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS, ICONS } from '../../common/constants';
import Actions from '../Actions';
import Avatar from '../Avatar';
import Button from '../Button';
import ContactForm from '../ContactForm';
import Empty from '../Empty';
import Icon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from './TableIndex';
import Tenant from '../Tenant';
import Search from '../Search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setContactFormData,
  clearContactFormData,
} from '../../store/actions/contactForm';
import { selectSearch } from '../../store/selectors/search';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { variables } from '../../Tenants';
import { serviceRequestTableLocalTime } from '../../helpers/validationHelper';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Checkbox from '../Checkbox';
import { onRequestPhoneCall } from '../../helpers/validationHelper';

class ContactsTable extends React.Component {
  state = {
    showOverlay: false,
  };

  onChange = (e) => {
    const { user } = this.props;
    if (e.type === 'Property Developer' || e.type === 'Homeowner') {
      e.propertyId = this.props.properties[0].propertyId;
    }
    if (this.state.formData.type === 'Homeowner') {
      this.props.fetchPropertySuites(
        e.propertyId,
        user.id,
        user.roles[0].role.name
      );
    }

    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        ...e,
      },
    });
  };

  render() {
    const {
      contacts,
      loader,
      onSubmitContactForm,
      onDeleteContact,
      onSearch,
      setContactFormData,
      clearContactFormData,
      sendResetPasswordLinkToUser,
      sendActivationLinkToUser,
      search,
      user,
      onSelectContact,
      selectedContacts,
      onSendInvitation,
    } = this.props;
    const { showOverlay } = this.state;

    return (
      <>
        {loader ? <Loader center={true} /> : null}
        <div className="contactsActionBtn">
          <Actions compact>
            <Search
              size="small"
              placeholder="Search Contacts..."
              onChange={onSearch}
            />
            <Button
              color="teal"
              label="Add Contact"
              onClick={() => {
                this.setState({ showOverlay: true });
                clearContactFormData();
                setContactFormData({
                  firstname: '',
                  lastname: '',
                  email: '',
                  phone: '',
                  type: 'default',
                });
              }}
              icon={<Icon glyph="user-plus" weight="regular" size="small" />}
              size="small"
            />
            {selectedContacts && selectedContacts.length > 0 && (
              <Button
                color="teal"
                label="Send invitation link"
                onClick={onSendInvitation}
                icon={
                  <Icon glyph="share-square" weight="regular" size="small" />
                }
                size="small"
              />
            )}
          </Actions>
        </div>
        {contacts.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: 'Contact',
                  sortable: true,
                  accessor: 'firstname',
                  cell: (data) => {
                    let selectedValue = selectedContacts.filter(
                      (sc) => sc.id === data.id
                    )[0];
                    let role =
                      data && data.roles && data.roles.length > 0
                        ? data.roles[0].role.name
                        : '';
                    let type =
                      data && data.roles && data.roles.length > 0
                        ? data.roles[0].role.name
                        : '';
                    return (
                      <div style={{ flexDirection: 'row', display: 'flex' }}>
                        {role !== 'Vendor' && data.status !== 'Active' ? (
                          <div style={{ marginTop: 16 }}>
                            <Checkbox
                              value={
                                selectedValue && selectedValue.id ? true : false
                              }
                              onChange={() => onSelectContact(data.id)}
                            />
                          </div>
                        ) : (
                          <div style={{ paddingLeft: 25 }}></div>
                        )}
                        <Link
                          to={{
                            pathname: PATHS.CONTACTS_VIEW.replace(
                              ':id',
                              data.id
                            ),
                            state: {
                              data: data,
                            },
                          }}
                        >
                          <Tenant
                            headline={`${data.firstname} ${data.lastname}`}
                            avatar={
                              <Avatar
                                badge={ICONS[type]}
                                url={data.profileImage}
                              />
                            }
                          />
                        </Link>
                      </div>
                    );
                  },
                },
                {
                  label: 'Role',
                  cell: (data) => {
                    if (data && data.roles.length > 0) {
                      if (data.roles[0].role.name === 'Property Developer') {
                        return variables.propertyDeveloper;
                      } else if (data.roles[0].role.name === 'Home Owner') {
                        return variables.homeOwner;
                      } else {
                        return data.roles[0].role.name;
                      }
                    }
                  },
                },
                {
                  label: 'Phone',
                  accessor: 'phone',
                  xsHide: true,
                  cell: (data) => onRequestPhoneCall(data.phone),
                },
                {
                  xsHide: true,
                  label: 'Email',
                  accessor: 'email',
                },
                {
                  xsHide: true,
                  label: <div style={{ textAlign: 'center' }}>Invited On</div>,
                  accessor: 'invitedOn',
                  cell: (data) => (
                    <div style={{ textAlign: 'center' }}>
                      {data.invitedOn
                        ? serviceRequestTableLocalTime(data.invitedOn)
                        : 'N/A'}
                    </div>
                  ),
                },
                {
                  xsHide: false,
                  sortable: true,
                  label: 'Property',
                  accessor: 'propertyName',
                  cell: (data) => (
                    <div style={{ textAlign: 'center' }}>
                      {data.propertyName ? (
                        <div title={data.propertyName}>{data.propertyName}</div>
                      ) : (
                        'N/A'
                      )}
                    </div>
                  ),
                },
                {
                  xsHide: true,
                  sortable: true,
                  label: <div style={{ textAlign: 'center' }}>Status</div>,
                  accessor: 'status',
                  cell: (data) => (
                    <div style={{ textAlign: 'center' }}>
                      {<div title={data.status}>{data.status}</div>}
                    </div>
                  ),
                },
                {
                  xsHide: true,
                  cell: (data) => (
                    <Hidden>
                      <Button
                        color="semantic"
                        label={<Icon glyph="pencil" weight="light" />}
                        onClick={() => {
                          this.setState({ showOverlay: true });
                          setContactFormData({ ...data, Suites: [] });
                        }}
                      />
                      <Button
                        color="semantic"
                        onClick={(e) =>
                          window.confirm(
                            `Are you sure you want to delete ${data.firstname} ${data.lastname}?`
                          ) && onDeleteContact(data)
                        }
                        label={<Icon glyph="trash" weight="light" />}
                      />
                    </Hidden>
                  ),
                },
              ]}
              data={contacts}
            />
          </>
        ) : (
          <Empty
            direction="ttb"
            headline="No contacts yet"
            strapline="Keep all your contacts here so it’s easier for you to manage."
            searchIsActive={search && search.contacts ? search.contacts : ''}
            cta={
              <>
                <Button
                  color="teal"
                  label="Add Contact"
                  onClick={() => {
                    this.setState({ showOverlay: true });
                    clearContactFormData();
                    setContactFormData({
                      firstname: '',
                      lastname: '',
                      email: '',
                      phone: '',
                      type: 'default',
                    });
                  }}
                  icon={<Icon glyph="user" weight="light" size="small" />}
                  size="small"
                />
              </>
            }
            image={
              <img alt="No contacts yet" src="/assets/empty/contacts.svg" />
            }
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <ContactForm
              onClose={() =>
                this.setState({ showOverlay: false }, () =>
                  clearContactFormData()
                )
              }
              onSubmit={(data, actionType) => {
                onSubmitContactForm(data, actionType);
              }}
              sendResetPasswordLinkToUser={sendResetPasswordLinkToUser}
              sendActivationLinkToUser={sendActivationLinkToUser}
            />
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  search: selectSearch(state),
  loader: selectFormLoader(state),
  user: selectAuthenticatedUser(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setContactFormData,
      clearContactFormData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContactsTable);
